import axios from 'axios'

export default {
  async getUsers (params) {
    // await this.sleep(1500)
    return await axios.get('/api/spa/v1/admin/user', { params })
  },
  async getUserById (id) {
    await this.sleep(1500)
    return await axios.get('/api/spa/v1/admin/user/' + id)
  },
  async updateUser (params) {
    return await axios.post('/api/spa/v1/admin/user/' + params.id, params)
  },
  async sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }
}
